<template>
  <div>
    <van-rate
      v-model="value"
      :size="26"
      :count="item.max"
      color="#ffd21e"
      void-icon="star"
      void-color="#eee"
      :disabled="readonly"
      style="padding: 15px 0;"
    />
    <span class="collect-form-item-rate-number">{{ value }}</span>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["item", "readonly", "row"],
  data() {
    return {
      value: this.initValue(),
    };
  },
  watch: {
    value: function (val) {
      if (this.row) {
        this.$set(this.row, "value", val);
      } else {
        this.$set(this.item, "value", val);
      }
    },
  },
  created() {},
  methods: {
    initValue() {
      let value = null;
      if (this.row) {
        if (this.row.value) {
          if (this.row.value instanceof Number) {
            value = this.row.value;
          } else {
            try {
              value = parseInt(this.row.value);
            } catch (error) {
              console.error(
                "rate renderer init value fail",
                this.row,
                this.item,
                error
              );
            }
          }
        }
      } else {
        if (this.item.value) {
          if (this.item.value instanceof Number) {
            value = this.item.value;
          } else {
            try {
              value = parseInt(this.item.value);
            } catch (error) {
              console.error("rate renderer init value fail", this.item, error);
            }
          }
        }
      }
      return value;
    },
  },
};
</script>
<style scoped>
</style>